<template>
     <div>
       <div  v-show="news.length>0" class="card page mb-5 p-2" style="width:1300px;margin:0 auto;box-shadow: 10px 10px 5px #888888;" id="v-content" :style="{minHeight:Height+'px'}">
             <p>
                  <span class="float-right span_close" style="display:block;width:20px;line-height:20px;text-align:center;font-size:25px;" @click="$router.go(-1)">
                           &times;
                  </span>
             </p>
            <div>
                  <div v-for="(item,index) in news" :key="index">
                  <div>
                      <p style="font-size:20px;text-align:center;" class="mt-2">{{item.title}}
                      </p>

                      <div v-html="item.content" class="mt-3">
                          {{item.content}}
                      </div>
                  </div>
                  </div>
            </div>
       </div>
     <div>
      <transition name="fade">
        <loading v-if="isLoading"></loading>
      </transition>
    </div>
  </div>
</template>
<script>
import Loading from '../components/Loading.vue'
export default {
  name:'news',
    data(){
    return {
           Height:0,
           news:[],
           id:'',
           isLoading:false,
           content:'',
    }
  },
   components:{
        Loading
    },
    methods:{
       //处理显示图片
       getImage(){
            this.news.forEach((item)=>{
                 item.content=item.content.replace(/@/g, "http://www.hyey.com/")
            })
       },
    getList: async function () {
        // this.isLoading=true;
    const {data: res} = await this.$http.get("http://124.112.116.187:8066/News/news",{
         
        })
        // console.log(res)
         let that=this;
         that.news=res.data;
         that.getImage();
      },
  
    },
     mounted(){
          //动态设置内容高度 让footer始终居底   header+footer的高度是100
    this.Height = document.documentElement.clientHeight - 100;  
　　//监听浏览器窗口变化　
    window.onresize = ()=> {this.Height = document.documentElement.clientHeight -100}
    },
    created(){
       this.getList()
    }
}   
</script>
<style scoped>
  .page{
    box-sizing: border-box;
    min-height: 100%;
    padding-bottom: 50px;
  }
  .span_close:hover{
       color:#3190e8;
 }
 
</style>



// WEBPACK FOOTER //
// src/pages/news.vue